<template>
    <div class="net-income-card">
        <el-card class="box-card" style="margin-bottom: 30px;" v-if="current_customer">
            <div slot="header" class="row d-flex align-items-center">
                <b-col cols="6">
                    <h3 class="mb-0">Commitment</h3>
                </b-col>
            </div>
            <div>
                <h4 class="mb-0">Total Joint Commitment</h4>
                <h3 class="text-primary">
                    RM{{ current_customer.customer_joint_profiles.reduce((total, item) => 
                        total + parseFloat(item.main_income.total_commitment ? item.main_income.total_commitment : 0), 0)
                        | moneyFormatter 
                    }}
                </h3>
                <hr class="my-3">
                <h4 class="badge bg-fintos">Individual</h4>
                <div v-for="(joint_profile, index) in current_customer.customer_joint_profiles" :key="index" class="mb-2">
                    <h4 class="mb-0">{{ joint_profile.name }}</h4>
                    <h3 class="text-primary">RM{{ joint_profile.main_income.total_commitment | moneyFormatter }}</h3>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'
    import { mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'

    export default {
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
        },
        data(){
            return{

            }
        },
        computed: {
            ...mapState(useCustomerStore,['current_customer'])
        },
    }
</script>